import { BASE_URL_SETTING } from '../routes.constants'
import type { Route } from '~/interfaces/routes.interfaces'

const base = `${BASE_URL_SETTING}/user`

export const SETTINGS_USER: Route = {
  path: base
}

export const SETTINGS_USER_CREATE: Route = {
  path: `${base}/create`
}

export const SETTINGS_USER_EDIT: Route = {
  path: `${base}/{id}`
}